import { API_ENDPOINTS, DOMAINS } from "../common/constants";

const getEnvironmentSuffix = (hostname) => {
  if (hostname) {
    if (hostname.includes(DOMAINS.DEV)) {
      return "-dev";
    } else if (hostname.includes(DOMAINS.STAGE)) {
      return "-stage";
    }
  }

  return "";
};

export const getConfig = () => {
  const hostname =
    typeof window !== "undefined" ? window?.location?.hostname : "";
  const localizationApiSuffix = getEnvironmentSuffix(hostname);

  return {
    domain: hostname ? `.${hostname.replace("www.", "")}` : "",
    host: hostname ? `//${hostname}` : "",
    localizationApiHost: `//localization${localizationApiSuffix}.thdws.com`,
    service: API_ENDPOINTS.LOCALIZATION_SERVICE,
    storeSearchService: API_ENDPOINTS.STORE_SEARCH_SERVICE,
    locationService: API_ENDPOINTS.LOCATION_SERVICE,
  };
};
